import styled, { css } from 'styled-components';
import {
  cvBreakpoint768,
  cvBreakpoint1024,
  cvBreakpoint1280,
  cvBreakpoint1920
 } from '@carvana/theme';
import * as Buttons from '@carvana/purchase-styles';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 40px 24px;
  width: 100%;
`;

export const HeadingContainer = styled.div`
  @media (min-width: ${cvBreakpoint768}px) {
    max-width: none;
  }
`;

export const Heading = styled.h2`
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
`;

export const BodyHeading = styled.h2`
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
`;

export const BodyText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 20px;
  padding-top: 10px;
  text-align: left;
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 93px;
  margin-top: 24px;

  @media (min-width: ${cvBreakpoint768}px) {
    margin-bottom: 35px;
  }
`;

export const FeatureList = styled.ul`
  color: ${props => props.theme.carvana.gray.dark};
  padding-top: 12px;
  padding-left: 20px;
`;

export const FeatureListItem = styled.li`
  color: ${props => props.theme.carvana.gray.dark};
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  &::marker {
    color: ${props => props.theme.carvana.blue.medium};
    width: 4px;
    height: 4px;
  }
`;

export const IconWrapper = styled.a`
  height: 60px;
  margin: 20px 20px 30px;
  display: flex;
  justify-content: center;
`;

export const LeftJustifiedContent = styled.div`
  max-width: 400px;

  @media (min-width: ${cvBreakpoint768}px) {
    max-width: none;
  }
`;

export const CartHeartIconWrapper = styled.img`
  height: 100%;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
`;

export const ButtonCheck = styled(Buttons.CarvanaButtonNoCaps)`
  width: 300px;
  background: #00aed9;
  color: white;
`;

export const Decline = styled.div`
  color: #00aed9;
  font-size: 16px;
  display: flex;
  justify-content: center;
`;

export const SubHeading = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  padding-top: 8px;
  font-size: 20px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
`;

export const modalContentStyles = css`
  background-color: white;
  min-height: 100px;
  z-index: 1301;

  @media (min-width: 350px) {
    max-width: 400px;
  }

  @media (min-width: 480px) {
    max-width: 400px;
  }

  @media (min-width: ${cvBreakpoint768}px) {
    max-width: 704px;
    overflow-x: hidden;
  }

  @media (min-width: ${cvBreakpoint1024}px) {
    max-width: 704px;
    overflow-x: hidden;
  }

  @media (min-width: ${cvBreakpoint1280}px) {
    max-width: 704px;
    overflow-x: hidden;
  }

  @media (min-width: ${cvBreakpoint1920}px) {
    max-width: 704px;
    overflow-x: hidden;
  }

  &.loading {
    overflow-y: visible;
  }
`;
